import { t } from "../../i18n";
import { backendApiCoverageStyles as styles } from "./backend-api-coverage-styles";
import type { BackendApiCoverageSnapshot } from "./backend-api-coverage-types";

interface SummaryProps {
  snapshot: BackendApiCoverageSnapshot;
}

export function BackendApiCoverageSummaryCards({
  snapshot,
}: SummaryProps): React.JSX.Element {
  const cards = [
    ["api_coverage.total_endpoints", snapshot.summary.total_endpoints],
    ["api_coverage.tested_endpoints", snapshot.summary.tested_endpoints],
    ["api_coverage.review_endpoints", snapshot.summary.review_endpoints],
    ["api_coverage.missing_endpoints", snapshot.summary.missing_endpoints],
    ["api_coverage.total_tests", snapshot.summary.total_tests],
    ["api_coverage.linked_test_entries", snapshot.summary.linked_tests],
    [
      "api_coverage.admin_frontend_exposed",
      snapshot.summary.admin_frontend_exposed_endpoints,
    ],
    [
      "api_coverage.admin_frontend_unexposed",
      snapshot.summary.admin_frontend_unexposed_endpoints,
    ],
  ];
  return (
    <div style={styles.cardGrid}>
      {cards.map(([label, value]) => (
        <div key={label} style={styles.card}>
          <span style={styles.cardLabel}>{t(String(label))}</span>
          <span style={styles.cardValue}>{String(value)}</span>
        </div>
      ))}
    </div>
  );
}
